import { routes as agenda } from '../modules/agenda'
import { routes as configuracoes } from '../modules/configuracoes'
import { routes as documentos } from '../modules/documentos'
import { routes as escritorios } from '../modules/escritorios'
import { routes as galeriaFotos } from '../modules/galeriaFotos'
import { routes as inicio } from '../modules/inicio'
import { routes as login } from '../modules/login'
import { routes as minhaConta } from '../modules/minhaConta'
import { routes as noticias } from '../modules/noticias'
import { routes as usuarios } from '../modules/usuarios'
import { routes as signup } from '../modules/signup'
import { routes as formasPagamento } from '../modules/formasPagamento'
import { routes as faturas } from '../modules/faturas'
import { routes as contratos } from '../modules/contratos'
import { routes as produtos } from '../modules/produtos'
import { routes as carrinho } from '../modules/carrinho'
import { routes as pedidos } from '../modules/pedidos'
// import { routes as consumo } from '../modules/consumo'
import { routes as recursosDisponiveis } from '../modules/recursosDisponiveis'
import { routes as emitentes } from '../modules/emitentes'
import { routes as politicaSeguranca } from '../modules/politicaSeguranca'

export default [
  ...inicio,
  ...minhaConta,
  ...configuracoes,
  ...galeriaFotos,
  ...documentos,
  ...noticias,
  ...contratos,
  ...usuarios,
  ...emitentes,
  ...politicaSeguranca,
  ...escritorios,
  ...formasPagamento,
  ...produtos,
  ...carrinho,
  ...agenda,
  ...pedidos,
  ...signup,
  ...faturas,
  // ...consumo,
  ...recursosDisponiveis,
  ...login
]
